import 'isomorphic-fetch';
import {config} from 'config'

export const api = {
	empresa:{
		async getAll() {
			const response = await fetch(config.URL_API + '/empresas/lista', {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
    clientes:{
		async create(data) {
            const response = await fetch(config.URL_API + '/clientes/alta', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            },
		    body: JSON.stringify(data)
        });
            const responseData = await response.json();
            return responseData;
        },
        async estado(data){
            const response = await fetch(config.URL_API + `/clientes/estado`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(data)
    	});
            const responseData = await response.json();
            return responseData;
        },
		async getAll(params = ''){
			const response = await fetch(config.URL_API + '/clientes&'+params, {
				method: 'GET',
				headers: {'Content-Type': 'application/x-www-form-urlencoded',},
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(config.URL_API + '/clientes/id/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async baja(data){
            const response = await fetch(config.URL_API + `/clientes/baja`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(data)
    	});
            const responseData = await response.json();
            return responseData;
        },
		async update(data){
            const response = await fetch(config.URL_API + '/clientes/modificar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(data)
    	});
            const responseData = await response.json();
            return responseData;
        },
    },
    localidades:{
		async getAll(params = ''){
			const response = await fetch(config.URL_API + '/localidades&'+params, {
				method: 'GET',
				headers: {'Content-Type': 'application/x-www-form-urlencoded',},
			});
			const data = await response.json();
			return data;
        },
        async get(id){
			const response = await fetch(config.URL_API + '/localidades/'+id, {
				method: 'GET',
				headers: {'Content-Type': 'application/x-www-form-urlencoded',},
			});
			const data = await response.json();
			return data;
		},
    },
    iva:{
		async getAll(params = ''){
			const response = await fetch(config.URL_API + '/condicionesiva&'+params, {
				method: 'GET',
				headers: {'Content-Type': 'application/x-www-form-urlencoded',},
			});
			const data = await response.json();
			return data;
		},
    },
    tipodoc:{
		async getAll(params = ''){
			const response = await fetch(config.URL_API + '/documentos&'+params, {
				method: 'GET',
				headers: {'Content-Type': 'application/x-www-form-urlencoded',},
			});
			const data = await response.json();
			return data;
		},
    },
    estadocta: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/cuentas_clientes/saldos&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async PDF(params = '') {
			const res = await fetch(config.URL_API + '/cuentas_clientes/pdfSaldos&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], 'Proveedor-Saldos.pdf', { type: 'application/pdf' })
			return file;
        },
	},
	entregas: {
		async create(data) {
			const response = await fetch(config.URL_API + '/entregas_clientes/alta', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async baja(data) {
			const response = await fetch(config.URL_API + `/entregas_clientes/baja`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async get(id) {
			const response = await fetch(config.URL_API + '/entregas_clientes/entrega/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async imprimir(id, mimeType) {
			const res = await fetch(config.URL_API + '/entregas_clientes/pdfEntrega/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: mimeType })
			return file;
		},
	},
	alicuotas: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/alicuotas&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	fpago: {
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/formas_pago&' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	cuentas_bancarias: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/cuentas_bancarias&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
};
